/**
 * SkipToContent — the first focusable element on a public page.
 *
 * Visually hidden until a keyboard user tabs to it, then it appears top-left
 * and jumps focus past the repeated nav straight to #main-content
 * (WCAG 2.4.1 Bypass Blocks). Every public page that renders this must also
 * put id="main-content" on its main content wrapper.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-200 focus:rounded focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-primary-foreground focus:shadow-lg focus:outline-hidden focus:ring-2 focus:ring-primary/40"
    >
      Skip to content
    </a>
  );
}
